import { contrastTextColor } from "../lib/color";

/** プロフィールのアイコン。無ければ表示名の頭文字を、その人の色地に出す */
export default function AvatarCircle({
  avatar,
  name,
  color,
  className,
}: {
  avatar: string | null | undefined;
  name: string | undefined;
  /** 頭文字の背景色。指定が無ければ従来どおりの無彩色 */
  color?: string;
  className: string;
}) {
  if (avatar !== null && avatar !== undefined) {
    return <img src={avatar} alt="" className={`rounded-full object-cover ${className}`} />;
  }
  return (
    <span
      className={`flex items-center justify-center rounded-full ${
        color === undefined ? "bg-[var(--color-line)] text-[var(--color-sub)]" : ""
      } ${className}`}
      style={
        color === undefined
          ? undefined
          : { backgroundColor: color, color: contrastTextColor(color) }
      }
    >
      {name?.slice(0, 1) ?? "?"}
    </span>
  );
}
